export const heroData = {
  tag: "51漫画官方发布页",
  title: "51漫画",
  subtitle: "免费版下载 · 在线观看",
  description: "汇聚海量热门漫画资源，支持51漫画APP下载、网页版在线看。无论你是寻找云缨巡街漫画免费入口，还是想体验最新51漫画免费版，这里都是你的最佳选择。",
  primaryButton: "立即下载",
  primaryLink: "#download",
  secondaryButton: "在线观看",
  secondaryLink: "#hot",
};

export const hotComics = [
  {
    id: 1,
    title: "云缨巡街",
    author: "墨香铜臭",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20female%20warrior%20walking%20through%20ancient%20Chinese%20street%20at%20night%2C%20lantern%20lights%2C%20traditional%20architecture%2C%20dynamic%20pose%2C%20ink%20wash%20painting%20style%20with%20modern%20manga%20aesthetic%2C%20warm%20red%20and%20gold%20accents%2C%20clean%20composition%2C%20soft%20gradient%20background%2C%20artistic%20rendering&width=800&height=1100&seq=comic-cover-01&orientation=portrait",
    views: "1280万",
    rating: 9.6,
    tags: ["热血", "武侠"],
  },
  {
    id: 2,
    title: "斗破苍穹",
    author: "天蚕土豆",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20of%20a%20young%20male%20cultivator%20with%20flame%20energy%20surrounding%20him%2C%20martial%20arts%20fantasy%20scene%2C%20dramatic%20lighting%2C%20fiery%20orange%20and%20gold%20color%20palette%2C%20dynamic%20action%20pose%2C%20ink%20and%20digital%20hybrid%20style%2C%20clean%20dark%20background%20with%20subtle%20glow%20effects%2C%20professional%20manga%20art&width=800&height=1100&seq=comic-cover-02&orientation=portrait",
    views: "2560万",
    rating: 9.8,
    tags: ["玄幻", "热血"],
  },
  {
    id: 3,
    title: "狐妖小红娘",
    author: "小新",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20beautiful%20fox%20spirit%20girl%20with%20flowing%20pink%20hair%20in%20traditional%20red%20hanfu%2C%20romantic%20fantasy%20atmosphere%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20ethereal%20lighting%2C%20watercolor%20and%20digital%20art%20style%2C%20warm%20pink%20and%20cream%20tones%2C%20clean%20dreamy%20composition%2C%20high%20quality%20anime%20illustration&width=800&height=1100&seq=comic-cover-03&orientation=portrait",
    views: "1890万",
    rating: 9.5,
    tags: ["恋爱", "奇幻"],
  },
  {
    id: 4,
    title: "一人之下",
    author: "米二",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20supernatural%20action%20scene%20with%20a%20male%20character%20using%20energy%20powers%2C%20urban%20fantasy%20setting%2C%20modern%20Chinese%20city%20backdrop%2C%20bold%20dynamic%20composition%2C%20dark%20green%20and%20gold%20color%20scheme%2C%20semi-realistic%20manga%20style%2C%20dramatic%20lighting%20effects%2C%20clean%20character-focused%20illustration&width=800&height=1100&seq=comic-cover-04&orientation=portrait",
    views: "2150万",
    rating: 9.7,
    tags: ["异能", "都市"],
  },
  {
    id: 5,
    title: "全职高手",
    author: "蝴蝶蓝",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20gaming%20theme%20with%20a%20cool%20male%20character%20holding%20gaming%20controller%2C%20futuristic%20digital%20background%20with%20neon%20lights%2C%20dynamic%20action%20feel%2C%20silver%20and%20cyan%20accents%20on%20dark%20background%2C%20modern%20manga%20illustration%20style%2C%20clean%20sharp%20composition&width=800&height=1100&seq=comic-cover-05&orientation=portrait",
    views: "1670万",
    rating: 9.4,
    tags: ["游戏", "竞技"],
  },
  {
    id: 6,
    title: "魔道祖师",
    author: "墨香铜臭",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20with%20two%20male%20characters%20in%20flowing%20white%20and%20black%20robes%2C%20ancient%20Chinese%20mountain%20landscape%20with%20mist%2C%20elegant%20and%20mysterious%20atmosphere%2C%20black%20ink%20and%20gold%20accents%2C%20traditional%20Chinese%20painting%20influence%20with%20modern%20manga%20style%2C%20clean%20dramatic%20composition&width=800&height=1100&seq=comic-cover-06&orientation=portrait",
    views: "3020万",
    rating: 9.9,
    tags: ["仙侠", "耽美"],
  },
];

export const categories = [
  {
    id: 1,
    name: "热血格斗",
    slug: "rexue",
    count: 1286,
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20action%20scene%20with%20two%20martial%20artists%20in%20intense%20combat%2C%20dynamic%20fight%20pose%2C%20energy%20bursts%2C%20warm%20red%20and%20orange%20tones%2C%20manga%20style%20speed%20lines%2C%20clean%20square%20composition%2C%20high%20contrast%20illustration&width=600&height=600&seq=cat-rexue&orientation=squarish",
  },
  {
    id: 2,
    name: "恋爱甜宠",
    slug: "lianai",
    count: 954,
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20romantic%20scene%20with%20a%20couple%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20gentle%20romantic%20atmosphere%2C%20watercolor%20style%20manga%20illustration%2C%20clean%20sweet%20composition%2C%20floating%20petals&width=600&height=600&seq=cat-lianai&orientation=squarish",
  },
  {
    id: 3,
    name: "悬疑推理",
    slug: "xuanyi",
    count: 632,
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20mystery%20detective%20scene%20with%20shadowy%20figure%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20moody%20lighting%20with%20single%20streetlamp%2C%20dark%20brown%20and%20amber%20tones%2C%20suspenseful%20composition%2C%20semi-realistic%20manga%20style&width=600&height=600&seq=cat-xuanyi&orientation=squarish",
  },
  {
    id: 4,
    name: "搞笑日常",
    slug: "gaoxiao",
    count: 1103,
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20comedy%20scene%20with%20chibi%20characters%20in%20funny%20expressions%2C%20bright%20colorful%20school%20setting%2C%20playful%20and%20lively%20atmosphere%2C%20cartoonish%20manga%20style%2C%20warm%20yellow%20and%20orange%20palette%2C%20clean%20humorous%20composition&width=600&height=600&seq=cat-gaoxiao&orientation=squarish",
  },
  {
    id: 5,
    name: "科幻未来",
    slug: "kehuan",
    count: 487,
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20sci-fi%20scene%20with%20futuristic%20cityscape%20and%20mecha%2C%20cyberpunk%20aesthetic%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20cool%20silver%20and%20teal%20tones%2C%20detailed%20digital%20illustration%2C%20clean%20futuristic%20composition&width=600&height=600&seq=cat-kehuan&orientation=squarish",
  },
  {
    id: 6,
    name: "仙侠玄幻",
    slug: "xianxia",
    count: 1520,
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20xianxia%20cultivation%20scene%20with%20floating%20immortal%20on%20clouds%2C%20ancient%20Chinese%20palace%20in%20background%2C%20mystical%20golden%20light%2C%20traditional%20ink%20painting%20style%20with%20digital%20enhancement%2C%20ethereal%20atmosphere%2C%20clean%20majestic%20composition&width=600&height=600&seq=cat-xianxia&orientation=squarish",
  },
];

export const faqData = [
  {
    id: 1,
    question: "51漫画免费版在哪里下载？",
    answer: "您可以通过本站提供的官方链接下载51漫画免费版APP。支持安卓和iOS双平台，安装后即可免费观看海量漫画资源。建议从本站获取最新版本，确保使用体验最佳且安全可靠。",
  },
  {
    id: 2,
    question: "云缨巡街漫画免费入口在哪里？",
    answer: "云缨巡街漫画是51漫画平台上的热门作品之一，您可以直接在51漫画APP或网页版搜索「云缨巡街」即可进入免费阅读。本站首页热门推荐区也提供了该作品的直达入口，点击即可开始阅读。",
  },
  {
    id: 3,
    question: "51漫画在线看需要注册吗？",
    answer: "51漫画提供游客模式免费观看，无需强制注册。但注册账号后可以享受收藏、历史记录、评论互动等更多功能，并且可以跨设备同步阅读进度。注册完全免费。",
  },
  {
    id: 4,
    question: "51漫画APP和网页版有什么区别？",
    answer: "51漫画APP提供更流畅的阅读体验和离线下载功能，适合移动端用户随时随地看漫画。网页版无需下载安装，直接在浏览器访问即可观看，适合偶尔使用的读者。两者内容完全同步。",
  },
  {
    id: 5,
    question: "51漫画的更新频率如何？",
    answer: "51漫画平台上的热门作品通常保持每日或每周更新。具体更新频率取决于各个作品的连载计划。您可以在APP中开启更新提醒，第一时间获知喜欢的漫画更新动态。",
  },
  {
    id: 6,
    question: "51漫画是否免费？有收费内容吗？",
    answer: "51漫画以免费阅读为核心特色，绝大部分内容均可免费观看。部分独家内容和抢先看章节可能需要观看广告或使用平台积分解锁。平台会不定期推出免费活动，让更多读者畅享阅读。",
  },
];

export const latestNews = [
  {
    id: 1,
    title: "51漫画2026年度热门榜单揭晓：这些作品你追了几部？",
    excerpt: "年度最受欢迎的51漫画作品排行榜正式公布，斗破苍穹、魔道祖师等经典作品持续霸榜，新锐作品强势崛起。",
    date: "2026-07-06",
    category: "榜单",
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20award%20ceremony%20scene%20with%20trophy%20and%20spotlights%2C%20golden%20and%20red%20color%20scheme%2C%20grand%20stage%20setting%2C%20celebration%20atmosphere%2C%20digital%20art%20illustration%20style%2C%20clean%20premium%20composition&width=1200&height=800&seq=news-01&orientation=landscape",
  },
  {
    id: 2,
    title: "云缨巡街漫画最新剧情解析：主角身世之谜即将揭晓",
    excerpt: "云缨巡街漫画最新一话信息量爆炸，主角云缨的神秘身世终于出现关键线索，粉丝们纷纷热议后续发展。",
    date: "2026-07-05",
    category: "解析",
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20story%20analysis%20scene%20with%20character%20silhouettes%20and%20mystery%20elements%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20dark%20tones%2C%20intriguing%20atmosphere%2C%20digital%20manga%20illustration%2C%20clean%20cinematic%20composition&width=1200&height=800&seq=news-02&orientation=landscape",
  },
  {
    id: 3,
    title: "51漫画APP全新版本上线：阅读体验全面升级",
    excerpt: "51漫画APP迎来重大版本更新，全新UI界面、智能推荐算法、夜间模式等多项功能上线，让阅读更加舒适便捷。",
    date: "2026-07-03",
    category: "公告",
    image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20Chinese%20manhua%20app%20interface%20with%20comic%20thumbnails%2C%20clean%20UI%20design%2C%20warm%20lighting%2C%20product%20showcase%20style%2C%20digital%20illustration%2C%20clean%20professional%20composition%2C%20soft%20gradient%20background&width=1200&height=800&seq=news-03&orientation=landscape",
  },
  {
    id: 4,
    title: "国产漫画崛起：51漫画平台助力原创作者成长",
    excerpt: "越来越多优秀的国产原创漫画通过51漫画平台走向大众，平台持续加大对原创作者的扶持力度，共同推动国漫发展。",
    date: "2026-07-01",
    category: "资讯",
    image: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20artist%20working%20at%20drawing%20tablet%20with%20character%20sketches%2C%20creative%20studio%20setting%2C%20warm%20natural%20light%2C%20inspirational%20atmosphere%2C%20digital%20art%20illustration%20style%2C%20clean%20artistic%20composition&width=1200&height=800&seq=news-04&orientation=landscape",
  },
  {
    id: 5,
    title: "暑假必看：51漫画精选书单，陪你度过炎热夏日",
    excerpt: "暑假来临，我们为大家精选了10部适合假期阅读的51漫画作品，涵盖热血、恋爱、搞笑等多种题材，总有一部适合你。",
    date: "2026-06-28",
    category: "推荐",
    image: "https://readdy.ai/api/search-image?query=Summer%20reading%20scene%20with%20stack%20of%20colorful%20Chinese%20manhua%20books%20and%20iced%20drink%2C%20bright%20sunny%20atmosphere%2C%20warm%20golden%20light%2C%20cozy%20relaxing%20vibe%2C%20digital%20illustration%20style%2C%20clean%20comfortable%20composition&width=1200&height=800&seq=news-05&orientation=landscape",
  },
];

export const siteInfo = {
  name: "51漫画",
  tagline: "免费漫画，快乐阅读",
  description: "51漫画是国内领先的免费漫画阅读平台，提供海量正版漫画资源。支持在线观看和APP下载，致力于为广大漫画爱好者提供优质的阅读体验。",
  established: "2018",
  email: "contact@51manhua.com",
  social: {
    weibo: "https://weibo.com/51manhua",
    wechat: "51漫画官方号",
    bilibili: "https://bilibili.com/51manhua",
    douyin: "https://douyin.com/51manhua",
  },
};